<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.query-title-div {
  width: 90px !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">订单管理</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营类别</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                v-model="queryInfo.isHostOperate"
                size="small"
                clearable
              >
                <el-option label="自运营" value="02"></el-option>
                <el-option label="代运营" value="01"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营商名称</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" v-model="queryInfo.dealNo" filterable size="small" clearable remote reserve-keyword>
                                <el-option v-for="item in dealNameArr" :key="item.dealNo" :label="item.dealName" :value="item.dealNo"></el-option>
                            </el-select>
              <!-- <el-input
                size="small"
                v-model="queryInfo.dealerName"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input> -->
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">手机号</div>
            <div class="query-inputs-div flex-1">
              <!-- <el-select class="full-width" v-model="queryInfo.phoneNum" filterable size="small" clearable remote reserve-keyword :remote-method="getMobileArr">
                                <el-option v-for="item in mobileArr" :key="item.mobile" :label="item.mobile" :value="item.mobile"></el-option>
                            </el-select> -->
              <el-input
                size="small"
                v-model="queryInfo.phoneNum"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">订单编号</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.orderNo"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">订单类型</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.sourceFrom"
                clearable
              >
                <el-option label="卡" value="01"></el-option>
                <el-option label="APP外部" value="02"></el-option>
                <el-option label="APP内部" value="03"></el-option>
                <el-option label="平台" value="04"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">订单状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.chargeStepCode"
                clearable
              >
                <el-option label="开始充电" value="01"></el-option>
                <el-option label="结束充电" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">订单属性</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.orderProperty"
                clearable
              >
                <el-option label="正常" value="01"></el-option>
                <el-option label="异常" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">用户评价</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.appraiseCode"
                clearable
              >
                <el-option label="未评价" value="00"></el-option>
                <el-option label="满意" value="01"></el-option>
                <el-option label="不满意" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">支付状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.payStatus"
                clearable
              >
                <el-option label="待支付" value="01"></el-option>
                <el-option label="已支付" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">电桩类型</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.pileType"
                clearable
              >
                <el-option label="私桩" value="01"></el-option>
                <el-option label="公桩" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">电站</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" v-model="queryInfo.stationNo" filterable size="small" clearable remote reserve-keyword>
                                <el-option v-for="item in stationNameArr" :key="item.stationName" :label="item.stationName" :value="item.stationNo"></el-option>
                            </el-select>
              <!-- <el-input
                size="small"
                v-model="queryInfo.stationName"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input> -->
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">系统时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                class="full-width"
                v-model="searchTime"
                :picker-options="pickerOptions"
                style="width:340px;"
                type="datetimerange"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateChange"
              ></el-date-picker>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">桩型号</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.pileTypeNo" filterable placeholder="请输入内容">
                                <el-option v-for="item in pileTypeNoArr" :key="item.pileTypeNo" :label="item.pileTypeNo" :value="item.pileTypeNo"></el-option>
                            </el-select>
              <!-- <el-input
                size="small"
                v-model="queryInfo.pileTypeCode"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input> -->
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">厂商标识</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.manufactureMark"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">软件版本</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.softVersion"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          
          <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">开始时间</div>
                        <div class="query-inputs-div flex-1">
                            <el-date-picker class="full-width" size="small" v-model="queryInfo.beginTime" type="datetime" placeholder="" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">结束时间</div>
                        <div class="query-inputs-div flex-1">
                            <el-date-picker class="full-width" size="small" v-model="queryInfo.endTime" type="datetime" placeholder="" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </div>
                    </div> -->
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                class="full-width"
                v-model="searchChargeTime"
                :picker-options="pickerOptions"
                style="width:340px;"
                type="datetimerange"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleChargeDateChange"
              ></el-date-picker>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电桩IMEI码</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.pileCode"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">开票状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.invoicingStatus"
                clearable
              >
                <el-option label="已开票" value="01"></el-option>
                <el-option label="未开票" value="00"></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <template slot="actions">
          <div class="">
            <button
              class="common-bg-button"
              @click="getListData(pagination, true)"
            >
              搜 索
            </button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </div>
          <div class="">
            <button
              class="common-bg-button"
              @click="toExportList"
              style="width:80px;margin-top:15px"
            >
              导出
            </button>
          </div>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {
        phoneNum: "",
        dtTo: "",
        dtFrom: "",
        pileType: "02",
        sourceFrom: "",
      },
      operates: {
        width: 180,
        fixed: "right",
        list: [
          {
            id: "report",
            label: "详情",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
              // this.$store.commit('setEditId', row.id)
              // this.$router.push({
              // 	name: pageConfig.orderDeatilRouter
              // });
              this.toDetail(row);
            },
          },
        ],
      }, // 列操作按钮
      searchTime: [],
      searchChargeTime: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dealNameArr: [],
      mobileArr: [],
      pileTypeNoArr: [],
      stationNameArr: [],
      dealerArr:[]
    };
  },
  methods: {
    getDealer() {
      let _ = this;
      _.$H.post(_, _.$A.dealer.allList, {}).then((res) => {
        _.dealerArr = res.data.data;
      });
    },
    // 判断页面路由是否存在手机号码/站点编号
    init() {
      
      if (this.$route.query.mobile) {
        this.queryInfo.phoneNum = this.$route.query.mobile;
      }
      if (this.$route.query.stationNo) {
        this.queryInfo.stationNo = this.$route.query.stationNo;
      }
      
      this.getListData(this.pagination, true);
      this.getPileTypeNo();
      this.getStationNameArr()
      this.getDealNameArr()
    },
    renderTime(date) {
                var dateee = new Date(date).toJSON();
                return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
            },

    getTime() {
     
      let stamp1 = new Date(new Date().setHours(0, 0, 0, 0)); //获取当天零点的时间
      let stamp2 = new Date(
        new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      ); //获取当天23:59:59的时间
      console.log(stamp1, stamp2);
      // this.searchChargeTime = [stamp1, stamp2];
      // this.queryInfo.beginTime = this.renderTime(stamp1);
      // this.queryInfo.endTime = this.renderTime(stamp2);

      this.searchTime = [stamp1, stamp2];
      this.queryInfo.dtFrom = this.renderTime(stamp1);
       this.queryInfo.dtTo = this.renderTime(stamp2);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      console.log(_.searchChargeTime);
      if(!_.searchTime || _.searchTime == null || _.searchTime.length == 0){
        return _.$message.error('请选择系统时间')
      }
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.order.getDtoList, _.queryInfo).then((res) => {
        _.tableData = res.data.data || [];
        // _.pagination.total = res.data.data.totalElements || 0;
      //   _.tableData.forEach(item=>{
        
      //   item.custPhone = item.custPhone?item.custPhone.replace(item.custPhone.substring(3,7), "****"):'';
       
      // })
        _.$U.hideLoading(_);
      });
      _.$H.post(_, _.$A.order.getDtoPageInfo, _.queryInfo).then((res) => {
        // _.tableData = res.data.data || [];
        _.pagination.total = res.data.data.totalElements || 0;
        // _.$U.hideLoading(_);
      });
    },
    resetPageIndex(val){
      if(val){
        
      }
    },
    getPileTypeNo() {
      let _ = this;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.order.findType, {}).then((res) => {
        _.pileTypeNoArr = res.data.data || [];
        _.$U.hideLoading(_);
      });
    },
    // 改方法已注销
    getDealNameArr(query) {
      let _ = this
        _.$H.post(_, _.$A.dealer.getDealList, {}).then((res) => {
          _.dealNameArr = res.data.data;
        });
      
    },
    // 改方法已注销
    getStationNameArr(query) {
      let _ = this;
      
        _.$H.post(_, _.$A.order.findStation, {}).then((res) => {
          _.stationNameArr = res.data.data;
        });
      
    },
    // 改方法已注销
    getMobileArr(query) {
      let _ = this;
      if (query.length >= 4) {
        //this.loading = true;
        var obj = {
          sort: "-mobile",
          mobile: query,
        };
        _.$H.post(_, _.$A.cust.findCustPhoneList, obj).then((res) => {
          _.mobileArr = res.data.data;
        });
      } else {
        this.mobileArr = [];
      }
    },
    //选择系统日期时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0];
        this.queryInfo.dtTo = val[1];
      } else {
        delete this.queryInfo.dtFrom;
        delete this.queryInfo.dtTo;
      }
    },
    //选择充电时间
    handleChargeDateChange(val) {
      if (val) {
        this.queryInfo.beginTime = val[0];
        this.queryInfo.endTime = val[1];
      } else {
        delete this.queryInfo.beginTime;
        delete this.queryInfo.endTime;
      }
    },
    // 页面新增方法
    listAddFun() {
      this.$S.listAddFun(this, pageConfig.tableEditObj);
    },
    // 页面编辑方法
    listEditFun() {
      this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
    },
    //下载页面
    toExportList() {
      let _ = this;
      // if(!_.searchTime || _.searchTime == null || _.searchTime.length == 0){
      //   return _.$message.error('请选择系统时间')
      // }
      if (_.queryInfo.dtFrom == "" || _.queryInfo.dtTo == "" || _.queryInfo.dtFrom == undefined || _.queryInfo.dtTo == undefined) {
          if (_.queryInfo.beginTime == "" || _.queryInfo.endTime == "" || _.queryInfo.beginTime == undefined || _.queryInfo.endTime == undefined) {
              _.$U.error("请选择充电时间或系统时间");
              return;
          } else {
              var t1 = new Date(Date.parse(_.queryInfo.endTime.replace(/-/g, "/"))) - new Date(Date.parse(_.queryInfo.beginTime.replace(/-/g, "/")));
              var t2 = Math.floor(t1 / (24 * 3600 * 1000));
              if (t2 >= "31") {
                  _.$U.error("充电时间范围不能超过31天");
                  return;
              }
          }
      } else {
          var k1 = new Date(Date.parse(_.queryInfo.dtTo.replace(/-/g, "/"))) - new Date(Date.parse(_.queryInfo.dtFrom.replace(/-/g, "/")));
          var k2 = Math.floor(k1 / (24 * 3600 * 1000));
          if (k2 >= "31") {
              _.$U.error("系统时间范围不能超过31天");
              return;
          }

          if (!_.queryInfo.beginTime == "" || !_.queryInfo.endTime == "" || !_.queryInfo.beginTime == undefined || !_.queryInfo.endTime == undefined) {
              var t1 = new Date(Date.parse(_.queryInfo.endTime.replace(/-/g, "/"))) - new Date(Date.parse(_.queryInfo.beginTime.replace(/-/g, "/")));
              var t2 = Math.floor(t1 / (24 * 3600 * 1000));
              if (t2 >= "31") {
                  _.$U.error("充电时间范围不能超过31天");
                  return;
              }
          }
      }
      
      if (_.queryInfo.pileType == "" || _.queryInfo.pileType == undefined) {
        _.$U.error("请选择电桩类型");
        return;
      }
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.order.exportOrderList, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        // var downUrl = "http://ocharge.shzhida.com:6775" + res.data.data.data;
        var downUrl = res.data.data.data;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },
    //表格详情
    toDetail(val) {
      let _ = this;
      var url = _.$router.resolve({ name: "orderDetail", query: { id: val.id,orderNo:val.orderNo,actElecFee:val.actElecFee,servFee:val.servFee } });
      window.open(url.href, "_blank");
    },
    //重置
    reset() {
      this.pagination.current = 1;
      delete this.queryInfo.dealerName;
      delete this.queryInfo.phoneNum;
      delete this.queryInfo.orderNo;
      delete this.queryInfo.sourceFrom;
      delete this.queryInfo.chargeStepCode;
      delete this.queryInfo.orderProperty;
      delete this.queryInfo.appraiseCode;
      delete this.queryInfo.payStatus;
      delete this.queryInfo.pileType;
      delete this.queryInfo.dtFrom;
      delete this.queryInfo.dtTo;
      delete this.queryInfo.stationName;
      delete this.queryInfo.beginTime;
      delete this.queryInfo.endTime;
      delete this.queryInfo.manufactureMark;
      delete this.queryInfo.softVersion;
      delete this.queryInfo.pileTypeCode;
      delete this.queryInfo.pileTypeNo;
      delete this.queryInfo.pileCode;
      delete this.queryInfo.contractType;
      this.searchTime = [];
      this.searchChargeTime = [];
      //this.init();
      console.log(this.searchChargeTime);
      this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.getTime();
    this.init();
  },
};
</script>
